import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useCollection } from '../../hooks/useFirestore'
import { SPELL_LEVELS, formatSpellLevel } from '../../lib/spellSchools'
import { useSpellSchools } from '../../hooks/useSpellSchools'
import './AdminEditor.css'

export default function SpellList() {
  const { data: spells, loading } = useCollection('spells', { orderByField: 'name' })
  const { schools, getSchoolName, getSchoolIcon } = useSpellSchools()
  const [levelFilter, setLevelFilter] = useState('all')
  const [schoolFilter, setSchoolFilter] = useState('all')

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner" />
      </div>
    )
  }

  // Apply filters
  let filteredSpells = spells
  if (levelFilter !== 'all') {
    filteredSpells = filteredSpells.filter(s => s.level === parseInt(levelFilter))
  }
  if (schoolFilter !== 'all') {
    filteredSpells = filteredSpells.filter(s => s.school === schoolFilter)
  }

  return (
    <div className="container">
      <div className="editor-header">
        <h1>Spells</h1>
        <Link to="/admin/spells/new" className="btn btn-primary">
          + New Spell
        </Link>
      </div>

      {/* Filters */}
      <div className="admin-filters">
        <div className="filter-group">
          <span className="filter-label">Level</span>
          <select
            value={levelFilter}
            onChange={(e) => setLevelFilter(e.target.value)}
          >
            <option value="all">All Levels</option>
            {SPELL_LEVELS.map(lvl => (
              <option key={lvl.value} value={lvl.value}>
                {lvl.label}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <span className="filter-label">School</span>
          <select
            value={schoolFilter}
            onChange={(e) => setSchoolFilter(e.target.value)}
          >
            <option value="all">All Schools</option>
            {schools.map(school => (
              <option key={school.slug} value={school.slug}>
                {school.icon} {school.name}
              </option>
            ))}
          </select>
        </div>

        <span className="filter-count">
          {filteredSpells.length} spell{filteredSpells.length !== 1 ? 's' : ''}
        </span>
      </div>

      {filteredSpells.length === 0 ? (
        <div className="empty-state">
          <p>No spells found.</p>
          <p className="text-secondary">
            {spells.length === 0
              ? 'Create your first custom spell.'
              : 'Try adjusting your filters.'}
          </p>
        </div>
      ) : (
        <div className="admin-list">
          {filteredSpells.map(spell => {
            const isHidden = spell.hidden === true
            const grantedCount = spell.grantedCharacterIds?.length || 0

            return (
              <Link
                key={spell.id}
                to={`/admin/spells/${spell.id}`}
                className={`admin-list-item ${isHidden ? 'hidden-item' : ''}`}
                style={{ opacity: isHidden ? 0.5 : 1 }}
              >
                <div className="item-info">
                  <h3>
                    {spell.name}
                    {isHidden && <span className="hidden-tag">Hidden</span>}
                  </h3>
                  <p className="text-secondary">
                    {formatSpellLevel(spell.level)} {getSchoolIcon(spell.school)} {getSchoolName(spell.school)}
                    {spell.concentration && ' (Concentration)'}
                  </p>
                </div>

                <div style={{ textAlign: 'right' }}>
                  <span className={`item-badge ${grantedCount > 0 ? 'badge-pc' : 'badge-npc'}`}>
                    {grantedCount} character{grantedCount !== 1 ? 's' : ''}
                  </span>
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
